import { render, staticRenderFns } from "./govheader.vue?vue&type=template&id=7d1c3d14&"
import script from "./govheader.vue?vue&type=script&lang=js&"
export * from "./govheader.vue?vue&type=script&lang=js&"
import style0 from "./govheader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports